<div class="container-header" [class.collapsed]="isCollapsed">
  <div nz-row class="header" [class.collapsed]="isCollapsed">
    <div nz-dropdown [nzDropdownMenu]="menu"
      class="user-container mobile-hidden" *ngIf="userData">
      <nz-avatar nzSize="large" [nzSrc]="userData.picture" [nzText]="(userData.given_name || userData.email || '?').charAt(0).toUpperCase()"></nz-avatar>
      <div class="info">
        <span class="name">{{userData.given_name}} {{userData.family_name}}</span>
        <span class="title-job">{{userData.email}}</span>
      </div>
      <span class="dropdown-icon" nz-icon nzType="down"></span>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <!-- <li nz-menu-item (click)="onGoToUserProfile()">Configuración de perfil</li> -->
        <li nz-menu-item nzDanger (click)="onLogout()">Cerrar sesión</li>
      </ul>
    </nz-dropdown-menu>

    <div class="mobile-header">
      <img src="assets/Diazar cloud.svg">
      <!-- <span>DIAZAR PM</span> -->
    </div>

    <div class="mobile-header">
      <nz-avatar *ngIf="userData" 
        nz-dropdown [nzDropdownMenu]="mobileMenu" nzTrigger="click"
        nzSize="default" [nzSrc]="userData.picture"></nz-avatar>
      <button nz-button nzType="text" (click)="toggle()">
        <span nz-icon nzType="menu"></span>
      </button>
    </div>
    <nz-dropdown-menu #mobileMenu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <!-- <li nz-menu-item (click)="onGoToUserProfile()">Configuración de perfil</li> -->
        <li nz-menu-item nzDanger (click)="onLogout()">Cerrar sesión</li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>
